
function cartView() {
	jQuery('#eight-cart').click(function(){
        jQuery(this).siblings('#dropdown-cart').toggleClass('activeCart');
	});
    jQuery('.close-cart').click(function(){
        jQuery(this).parents('#dropdown-cart').removeClass('activeCart');
	});
}
jQuery(document).ready(function() {
    // Fixed header
    jQuery(window).scroll(function() {    
        var scroll = jQuery(window).scrollTop();
      
        if (scroll >= 10) {
            jQuery("header").addClass("Fixed");
        } else {
            jQuery("header").removeClass("Fixed");
        }
    });
    // End Fixed header
    cartView();

    // Mmenu 
    new Mmenu( "#main_menu", {
        // options
        "extensions": [
                //"pageshadow",
                "theme-white",
                "position-right",
                //"position-left"
        ]
    }, {
        // configuration
        offCanvas: {
            clone: true
        }
    });
    // toggle-search
    jQuery("#search-btn").click(function(){
        jQuery(".search-field").toggle();
        jQuery(".header-links").hide();
    });
   // toggle-user
    jQuery("#user-btn").click(function(){
        jQuery(".header-links").toggle();
        jQuery(".search-field").hide();
    });

    jQuery(".Categories").slick({
    dots: false,
    arrows:true,
    autoplay:true,
    autoplaySpeed:4500,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 1100,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            adaptiveHeight: true,
        },
        },
        {
        breakpoint: 991,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            adaptiveHeight: true,
            dots: false,
            arrows:true,
        },
        },
        {
        breakpoint: 800,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
        },
        },
    ],
    });

    // review slick slider
    jQuery('.review-slider').slick({
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    swipe: true,
    //  infinite: true,
    swipeToSlide: true,
    centerPadding: '0',
    //adaptiveHeight: true,
    responsive: [
        {
        breakpoint: 1100,
        settings: {
            slidesToShow: 3,
            adaptiveHeight: true,
        },
        },
        {
            breakpoint: 991,
            settings: {
            slidesToShow: 2,
            adaptiveHeight: true,
            dots: false,
            arrows:true,
            },
        },
        {
            breakpoint: 800,
            settings: {
            slidesToShow: 2,
            },
        },
        ],
    });

    jQuery(".chakra").slick({
        dots: true,
        arrows:false,
        autoplay:true,
        autoplaySpeed:4500,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
         {
           breakpoint: 1100,
           settings: {
             slidesToShow: 2,
             slidesToScroll: 1,
             adaptiveHeight: true,
           },
         },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              adaptiveHeight: true,
              dots: true,
              arrows:false,
            },
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows:false,
            },
          },
        ],
    });

    // review slick slider
    jQuery('.best-seller-row').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1500,
        responsive: [
            {
            breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
            }
        ]
    });
    /* wow js */
    wow = new WOW({
        animateClass: 'animated',
        offset:       100,
        callback:     function(box) {
        //console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
        }
    });
    wow.init();
});   